import styled from "astroturf";

export const MainTransitionContainer = styled("div")`
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  position: absolute;
  width: 100%;
  height: 100%;
`;
